module.exports = __webpack_public_path__ + "img/ic-chat-message.60691975.svg";